import {
  GET_PROVINCE_ERR,
  GET_PROVINCE_OK,
  DELETE_PROVINCE_ERR,
  DELETE_PROVINCE_OK,
  CREATE_PROVINCE_ERR,
  UPD_PROVINCE_ERR,
  UPD_PROVINCE_OK,
} from "./province.action";

const InitState = {
  error: null,
  content: null,
};

export default function ProvinceAdmReducer(state = InitState, action) {
  switch (action.type) {
    case GET_PROVINCE_OK: {
      return {
        ...state,
        error: null,
        content: action.payload.content,
      };
    }
    case GET_PROVINCE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: null,
      };
    }
    case DELETE_PROVINCE_OK: {
      const id = action.payload.Id;
      return {
        ...state,
        error: null,
        content: {
          items: state.content.items.filter((item) => item.id !== id),
        },
      };
    }
    case DELETE_PROVINCE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    case CREATE_PROVINCE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    case UPD_PROVINCE_OK: {
      const itemParameter = action.payload;
      return {
        ...state,
        content: {
          items: state.content.items.map((item) =>
            item.id === itemParameter.id
              ? // transform the one with a matching id
                {
                  ...item,
                  name: itemParameter.name,
                }
              : // otherwise return original todo
                item
          ),
        },
      };
    }
    case UPD_PROVINCE_ERR: {
      return {
        ...state,
        error: action.payload.err,
        content: state.content,
      };
    }
    default:
      return state;
  }
}
